export enum PersonKind {
    Juridical = 'Juridical',
    Natural = 'Natural'
}
